The SEEK Ad Sync identifier for the hirer.

This is assigned by SEEK when the hirer is onboarded to Ad Sync.
This field must be exactly 24 characters.
